export enum TopHoldingsTableType {
  WEIGHT,
  NET_IMPACT_RATIO,
}
